import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { Page, ValuePropKey } from "@/utils/enum";
import CharterUPValueProp from "./CharterUPValueProp.vue";
import SalesBotFooterValueProp from "./SalesBotFooterValueProp.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheSalesBotFooter',
  props: {
  padded: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



const isExpanded = ref(false);

const page = Page.SalesBot;
const valuePropKeys: ValuePropKey[] = [
  ValuePropKey.BookingProtection,
  ValuePropKey.Tracking,
  ValuePropKey.LiveSupport,
  ValuePropKey.QualifiedOperators,
];

return { __sfc: true,isExpanded, page, valuePropKeys, CharterUPValueProp, SalesBotFooterValueProp }
}

})